/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Prices_Gift_BuyInputs */

const en_prices_gift_buy = /** @type {(inputs: Prices_Gift_BuyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buy a gift card for a friend`)
};

const es_prices_gift_buy = /** @type {(inputs: Prices_Gift_BuyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compra una tarjeta de regalo para un amigo`)
};

const de_prices_gift_buy = /** @type {(inputs: Prices_Gift_BuyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kaufen Sie eine Geschenkkarte für einen Freund`)
};

const zh_prices_gift_buy = /** @type {(inputs: Prices_Gift_BuyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`为朋友购买礼品卡`)
};

const ar_prices_gift_buy = /** @type {(inputs: Prices_Gift_BuyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`اشترِ بطاقة هدية لصديق`)
};

const fr_prices_gift_buy = /** @type {(inputs: Prices_Gift_BuyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acheter une carte cadeau pour un ami`)
};

const vi_prices_gift_buy = /** @type {(inputs: Prices_Gift_BuyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mua thẻ quà tặng cho bạn bè`)
};

const sw_prices_gift_buy = /** @type {(inputs: Prices_Gift_BuyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nunua kadi ya zawadi kwa rafiki`)
};

const th_prices_gift_buy = /** @type {(inputs: Prices_Gift_BuyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ซื้อบัตรของขวัญให้เพื่อน`)
};

const bs_prices_gift_buy = /** @type {(inputs: Prices_Gift_BuyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kupite poklon karticu za prijatelja`)
};

const ja_prices_gift_buy = /** @type {(inputs: Prices_Gift_BuyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`友人にギフトカードを購入`)
};

const ko_prices_gift_buy = /** @type {(inputs: Prices_Gift_BuyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`친구에게 줄 기프트 카드 구매`)
};

const pt_prices_gift_buy = /** @type {(inputs: Prices_Gift_BuyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compre um cartão-presente para um amigo`)
};

const it_prices_gift_buy = /** @type {(inputs: Prices_Gift_BuyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acquista una carta regalo per un amico`)
};

const sv_prices_gift_buy = /** @type {(inputs: Prices_Gift_BuyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Köp ett presentkort för en vän`)
};

const nl_prices_gift_buy = /** @type {(inputs: Prices_Gift_BuyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Koop een cadeaubon voor een vriend`)
};

const da_prices_gift_buy = /** @type {(inputs: Prices_Gift_BuyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Køb et gavekort til en ven`)
};

const nb_prices_gift_buy = /** @type {(inputs: Prices_Gift_BuyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kjøp et gavekort til en venn`)
};

const fi_prices_gift_buy = /** @type {(inputs: Prices_Gift_BuyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Osta lahjakortti ystävälle`)
};

const pl_prices_gift_buy = /** @type {(inputs: Prices_Gift_BuyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kup kartę podarunkową dla przyjaciela`)
};

const ru_prices_gift_buy = /** @type {(inputs: Prices_Gift_BuyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Купить подарочную карту для друга`)
};

const tr_prices_gift_buy = /** @type {(inputs: Prices_Gift_BuyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bir arkadaş için hediye kartı satın alın`)
};

const hi_prices_gift_buy = /** @type {(inputs: Prices_Gift_BuyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`एक दोस्त के लिए एक उपहार कार्ड खरीदें`)
};

const id_prices_gift_buy = /** @type {(inputs: Prices_Gift_BuyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beli kartu hadiah untuk teman`)
};

const ms_prices_gift_buy = /** @type {(inputs: Prices_Gift_BuyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Belikan kad hadiah untuk rakan`)
};

const cs_prices_gift_buy = /** @type {(inputs: Prices_Gift_BuyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Koupit dárkovou poukázku pro přítele`)
};

const el_prices_gift_buy = /** @type {(inputs: Prices_Gift_BuyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Αγοράστε μια δωροκάρτα για έναν φίλο`)
};

const he_prices_gift_buy = /** @type {(inputs: Prices_Gift_BuyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`קנו כרטיס מתנה לחבר`)
};

const af_prices_gift_buy = /** @type {(inputs: Prices_Gift_BuyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Koop 'n geskenkkaart vir 'n vriend`)
};

const hu_prices_gift_buy = /** @type {(inputs: Prices_Gift_BuyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vásároljon ajándékkártyát egy barátjának`)
};

/**
* | output |
* | --- |
* | "Buy a gift card for a friend" |
*
* @param {Prices_Gift_BuyInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const prices_gift_buy = /** @type {((inputs?: Prices_Gift_BuyInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Prices_Gift_BuyInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_prices_gift_buy(inputs)
	if (locale === "de") return de_prices_gift_buy(inputs)
	if (locale === "zh") return zh_prices_gift_buy(inputs)
	if (locale === "ar") return ar_prices_gift_buy(inputs)
	if (locale === "fr") return fr_prices_gift_buy(inputs)
	if (locale === "vi") return vi_prices_gift_buy(inputs)
	if (locale === "sw") return sw_prices_gift_buy(inputs)
	if (locale === "th") return th_prices_gift_buy(inputs)
	if (locale === "bs") return bs_prices_gift_buy(inputs)
	if (locale === "ja") return ja_prices_gift_buy(inputs)
	if (locale === "ko") return ko_prices_gift_buy(inputs)
	if (locale === "pt") return pt_prices_gift_buy(inputs)
	if (locale === "it") return it_prices_gift_buy(inputs)
	if (locale === "sv") return sv_prices_gift_buy(inputs)
	if (locale === "nl") return nl_prices_gift_buy(inputs)
	if (locale === "da") return da_prices_gift_buy(inputs)
	if (locale === "nb") return nb_prices_gift_buy(inputs)
	if (locale === "fi") return fi_prices_gift_buy(inputs)
	if (locale === "pl") return pl_prices_gift_buy(inputs)
	if (locale === "ru") return ru_prices_gift_buy(inputs)
	if (locale === "tr") return tr_prices_gift_buy(inputs)
	if (locale === "hi") return hi_prices_gift_buy(inputs)
	if (locale === "id") return id_prices_gift_buy(inputs)
	if (locale === "ms") return ms_prices_gift_buy(inputs)
	if (locale === "cs") return cs_prices_gift_buy(inputs)
	if (locale === "el") return el_prices_gift_buy(inputs)
	if (locale === "he") return he_prices_gift_buy(inputs)
	if (locale === "af") return af_prices_gift_buy(inputs)
	if (locale === "hu") return hu_prices_gift_buy(inputs)
	return en_prices_gift_buy(inputs)
});